export class EmployeeInfo {
    employeeId: string;
    firstName: string;
    lastName: string;
    grade: string;
    project: string;
    isProjectAllocated: boolean;
    isCertified: boolean;
    experience: number;
    skill: string[];
    managerEmpCode: number;
    profilePicture: string;
    location: string;
    finishedCertificationIds: number[];
    isSME: boolean;
    smEs: [];
    expertises: [];
    managerFirstName: string;
    managerLastName: string;
    competencyName: string;
    tagCloud: string;
    score: number;
}
